export default {
  props: {
    property: {
      type: Object,
      default: () => ({id: null})
    },
    validator: {
      type: Function,
      default: () => true
    }
  },
  data: function () {
    return {
      isValid: true
    }
  },
  computed: {
    val: {
      get: function () {
        const value = this.property.value
        const isValid = this.validator(value)
        this.$emit('onChangeValidation', {
          code: this.property.code,
          value: isValid
        })
        this.isValid = isValid
        return value
      },
      set: function (val) {
        this.$emit('onChangeValue', {
          code: this.property.code,
          value: val
        })
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/Personal/PersonalProfile/Inputs/Parent.js